import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "@/components/icons";
import api, { formatErr } from "../lib/api";
import { AuthCard, FlatInput, PrimaryButton } from "./Login";

/**
 * ForgotPassword — estilo minimalista "Files Management".
 * Fondo blanco full-screen. Paleta blanco / gris #F2F3F5 / negro.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center p-4 sm:p-6">
      <AuthCard>
        <div className="flex justify-center mb-8">
          <img
            src="/brand/consudoctor-icon.png"
            alt="ConsuDoctor"
            className="h-12 w-12 object-contain"
          />
        </div>

        {!sent ? (
          <div data-testid="forgot-password-card">
            <h1 className="text-center text-3xl sm:text-[32px] font-semibold text-black tracking-tight leading-tight">
              ¿Olvidaste tu contraseña?
            </h1>
            <p className="text-center text-sm text-black/50 mt-2">
              Ingresa tu correo y te enviaremos un enlace para crear una nueva.
            </p>

            <form onSubmit={submit} className="mt-8 space-y-3">
              <FlatInput
                label="Email"
                type="email"
                value={email}
                onChange={setEmail}
                placeholder="tucorreo@consudoctor.com"
                testId="forgot-email-input"
                autoComplete="email"
              />

              {err && (
                <div
                  data-testid="forgot-error"
                  className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-xl px-4 py-2.5"
                >
                  {err}
                </div>
              )}

              <PrimaryButton
                type="submit"
                loading={loading}
                testId="forgot-submit-btn"
              >
                Enviar enlace
              </PrimaryButton>
            </form>

            <div className="mt-8 text-center">
              <Link
                to="/login"
                data-testid="back-to-login-link"
                className="inline-flex items-center gap-1.5 text-xs font-medium text-black/60 hover:text-black transition"
              >
                <ArrowLeft className="w-3.5 h-3.5" /> Volver al inicio de sesión
              </Link>
            </div>
          </div>
        ) : (
          <div className="text-center" data-testid="forgot-success">
            <div className="w-12 h-12 mx-auto rounded-full bg-[#F2F3F5] flex items-center justify-center">
              <CheckCircle2 className="w-6 h-6 text-black" />
            </div>
            <h1 className="mt-6 text-2xl sm:text-[28px] font-semibold text-black tracking-tight">
              Revisa tu correo
            </h1>
            <p className="mt-3 text-sm text-black/60 leading-relaxed">
              Si <strong className="text-black">{email}</strong> está registrado,
              te enviamos un enlace para restablecer tu contraseña. Revisa también
              la carpeta de spam.
            </p>
            <p className="mt-3 text-xs text-black/40">
              El enlace expira en 60 minutos.
            </p>
            <Link
              to="/login"
              className="mt-7 inline-block w-full bg-black hover:bg-black/90 text-white rounded-xl py-3.5 text-[15px] font-semibold transition"
            >
              Volver al inicio de sesión
            </Link>
          </div>
        )}
      </AuthCard>
    </div>
  );
}
